module.exports = __webpack_public_path__ + "img/11_pc.6240889b.gif";